import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  ComponentRendering,
  RichTextField,
} from '@sitecore-jss/sitecore-jss-angular';
import { FormState, MarkAsTouchedAction, NgrxFormsModule } from 'ngrx-forms';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { TrackValueChangeDirective } from '@analytics/events';
import { GenericRichTextDirective } from '@core/jss-utils';

@Component({
  selector: 'wl-toggle',
  templateUrl: './toggle.component.html',
  styleUrls: ['./toggle.component.ed.scss', './toggle.component.essent.scss'],
  standalone: true,
  imports: [
    AutomationIdDirective,
    NgrxFormsModule,
    TrackValueChangeDirective,
    GenericRichTextDirective,
  ],
})
export class ToggleComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() toggleId?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() labelText?: RichTextField;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() formControl?: FormState<boolean>;

  _checked = false;
  get checked(): boolean {
    return this._checked;
  }
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() set checked(value: boolean) {
    this._checked = value;
    this.checkedChange.emit(value);
  }

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() fieldName?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() stepName?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() formName?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: ComponentRendering;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() name?: string;

  @Output()
  // eslint-disable-next-line @angular-eslint/no-output-native
  toggle = new EventEmitter<Event>();
  @Output() checkedChange = new EventEmitter<boolean>();

  private _markedAsTouched = false;

  public onChange(event: Event) {
    this.toggle.emit(event);

    if (!this._markedAsTouched) {
      this.markAsTouched();
      this._markedAsTouched = true;
    }
  }

  public markAsTouched() {
    if (this.formControl) {
      this.store$.dispatch(new MarkAsTouchedAction(this.formControl.id));
    }
  }

  constructor(private readonly store$: Store<any>) {}
}
